import { createFileRoute } from "@tanstack/react-router";
import WaterMeasurementProtocolPage from "pages/app/ProvtagningsPage/WaterMeasurementProtocolPage";

export const Route = createFileRoute(
  "/_authenticated/app/uppdrag/$uuid/provtagning/$pid",
)({
  component: WaterMeasurementProtocolPage,
});
